import { Typography, TextField, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useMemo, useState } from "react";
import ServiceItemCard from "./ServiceItemCard";

const ServicesList = ({
  services,
  language,
  selectedServices,
  serviceQuantities,
  onServiceToggle,
  onQuantityChange,
  onSuggestClick
}) => {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredServices = useMemo(() => {
    if (!searchQuery.trim()) return services;
    
    const query = searchQuery.toLowerCase();
    return services.filter(service => 
      service.name[language]?.toLowerCase().includes(query) ||
      service.description?.[language]?.toLowerCase().includes(query)
    );
  }, [services, searchQuery, language]);

  const isServiceSelected = (serviceId) => {
    return selectedServices.some((s) => s._id === serviceId);
  };

  const getServiceQuantity = (serviceId) => {
    return serviceQuantities[serviceId] || 0;
  };

  return (
    <div className="section-container">
      <Typography variant="h6" component="h3" className="section-title">
        {language === "ar" ? "الخدمات" : "Services"}
      </Typography>

      <TextField
        fullWidth
        placeholder={language === "ar" ? "ابحث عن خدمة..." : "Search for a service..."}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        InputProps={{
          startAdornment: <SearchIcon style={{ marginLeft: language === "ar" ? "8px" : "0", marginRight: language === "ar" ? "0" : "8px", color: "#666" }} />,
        }}
        sx={{
          marginBottom: "16px",
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#ddd",
            },
            "&:hover fieldset": {
              borderColor: "#4CAF50",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#4CAF50",
            },
          },
        }}
      />

      <div className="services-list">
        {filteredServices.length > 0 ? (
          filteredServices.map((service) => (
            <ServiceItemCard
              key={service._id}
              item={service}
              isUtility={false}
              isSelected={isServiceSelected(service._id)}
              quantity={getServiceQuantity(service._id)}
              language={language}
              onToggle={onServiceToggle}
              onQuantityChange={onQuantityChange}
            />
          ))
        ) : (
          <Typography className="no-services-message">
            {searchQuery 
              ? (language === "ar" ? "لا توجد خدمات مطابقة للبحث" : "No services match your search")
              : (language === "ar" ? "لا توجد خدمات متاحة لهذا القسم" : "No services available for this department")
            }
          </Typography>
        )}
      </div>

      <Button
        variant="outlined"
        fullWidth
        onClick={onSuggestClick}
        sx={{
          marginTop: "16px",
          textTransform: "none",
          borderStyle: "dashed",
          borderWidth: 2,
          padding: "12px",
          "&:hover": {
            borderWidth: 2,
            borderStyle: "dashed",
          },
        }}
      >
        {language === "ar" ? "اقترح خدمة غير موجودة" : "Suggest Service Not Found"}
      </Button>
    </div>
  );
};

export default ServicesList;